import React from 'react'
import { Redirect, useLocation } from 'react-router-dom'

import { Loader } from '../components/loader'
import { useAuthentication } from '../customHooks/useAuthentication'
import usePublicPlans from '../views/Subscription/hooks/usePublicPlans'
import { isSuperAdminUser } from '../views/Dashboard/saasAdmin.utils'
import {
  companyHasAnyPlanModuleAccess,
  companyHasLegacyModuleNames,
  companyHasVendorBillsAccess,
  isCatalogAvailable,
} from '../utils/planModuleAccess'
import { getCachedPublicPlansCatalog } from '../services/publicPlansCatalog'
import paths from './paths'

function resolveAccess(userInfo, catalogPlans, catalogAvailable, fetchError, { module, modules, legacyModuleNames, vendorBills }) {
  const options = { catalogAvailable, fetchError }
  if (vendorBills) return companyHasVendorBillsAccess(userInfo, catalogPlans, options)
  if (legacyModuleNames?.length && companyHasLegacyModuleNames(userInfo, legacyModuleNames)) return true
  const keys = modules?.length ? modules : module ? [module] : []
  if (!keys.length) return false
  return companyHasAnyPlanModuleAccess(userInfo, catalogPlans, keys, options)
}

/**
 * Route guard by commercial plan module (GET /api/public/plans) OR package `module_in_package`.
 */
export default function ModuleGuardRoute({
  children,
  module,
  modules,
  legacyModuleNames,
  vendorBills = false,
  bypass = false,
  redirectTo = paths.accessDenied,
}) {
  const { userInfo } = useAuthentication()
  const location = useLocation()
  const { plans, isLoading, fetchError } = usePublicPlans()
  const catalogAvailable = isCatalogAvailable(plans, fetchError)
  if (bypass || isSuperAdminUser(userInfo)) return children
  const hasCachedCatalog = Boolean(getCachedPublicPlansCatalog()?.length)
  if (isLoading && !hasCachedCatalog && !catalogAvailable) {
    return <Loader variant="page" />
  }
  const allowed = resolveAccess(userInfo, plans, catalogAvailable, fetchError, {
    module,
    modules,
    legacyModuleNames,
    vendorBills,
  })
  if (!allowed) {
    const deniedModule = module || (modules && modules[0]) || 'module'
    return <Redirect to={{ pathname: redirectTo, state: { from: location, reason: 'module', module: deniedModule } }} />
  }
  return children
}
